import React from "react";
import { ConfigProvider, Typography, Spin, Empty, Pagination } from "antd";
import { useTranslation } from "react-i18next";
import { reviTheme } from "../../../../theme/reviTheme";
import {
  TherapistPatientsFilters,
  TherapistPatientModal,
} from "../../../../components/Admin/TherapistCmp/PatientCmp";
import { PatientCardLite } from "../../../../components/Admin/uiComponents";
import { useTherapistPacientesController } from "./useTherapistPacientesController";
import "./Page_Therapist_Pacientes.scss";

const { Title, Text } = Typography;

export function Page_Therapist_Pacientes() {
  const { t } = useTranslation("therapist");

  const {
    patients,
    loading,
    pagination,
    filters,
    onSearch,
    onSexo,
    onPageChange,

    // modal
    isModalOpen,
    activeTab,
    selectedPatient,
    profileLoading,
    profileError,
    openPatientModal,
    closePatientModal,
    setActiveTab,
    updateClinicalInfoLocal,
  } = useTherapistPacientesController();

  return (
    <ConfigProvider theme={reviTheme}>
      <div className="revi-page-pacientes">
        <div className="revi-page-pacientes__main">
          <div className="revi-page-pacientes__header">
            <Title level={2} style={{ marginBottom: 6 }}>
              {t("pacientes.titulo")}
            </Title>
            <Text type="secondary" className="revi-subtitulo-pagina">
              {t("pacientes.subtitulo")}
            </Text>
          </div>

          <div className="revi-page-pacientes__filters">
            <TherapistPatientsFilters
              search={filters.search}
              sexo={filters.sexo}
              onSearch={onSearch}
              onSexo={onSexo}
            />
          </div>

          <div className="revi-page-pacientes__grid-wrapper">
            {loading ? (
              <div className="loader-container">
                <Spin size="large" />
              </div>
            ) : patients.length === 0 ? (
              <div className="empty-container">
                <Empty description={t("pacientes.vacio")} />
              </div>
            ) : (
              <div className="patients-grid">
                {patients.map((p) => (
                  <PatientCardLite
                    key={p._id}
                    patient={p}
                    onView={(id) => openPatientModal(id, "detail")}
                    onEvaluations={(id) => openPatientModal(id, "evaluations")}
                  />
                ))}
              </div>
            )}
          </div>

          {pagination.totalDocs > 0 ? (
            <div className="revi-page-pacientes__pagination">
              <Pagination
                current={pagination.page}
                pageSize={pagination.limit}
                total={pagination.totalDocs}
                onChange={onPageChange}
                showSizeChanger={false}
              />
            </div>
          ) : null}
        </div>
      </div>

      <TherapistPatientModal
        open={isModalOpen}
        onClose={closePatientModal}
        patient={selectedPatient}
        loading={profileLoading}
        error={profileError}
        activeTab={activeTab}
        onTabChange={setActiveTab}
        onClinicalInfoUpdate={updateClinicalInfoLocal}
      />
    </ConfigProvider>
  );
}
